import { styled } from "styled-components";
import { useContext } from "react";
import Context from "../../Context.js";
import { AiOutlineDown } from "react-icons/ai";
import PopupSelect from "./PopupSelect.js";
import goTo from "../../controllers/goTo.js";

const Container = styled.div`
  display: flex;
  flex-direction: row;
  padding: 10px 15px;
  width: 100%;
  background: var(--surface);
  border: 1px solid var(--border);
  color: var(--element);
  /* box-shadow: var(--lightShadow); */

  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  border-radius: 10px;
  gap: 10px;
`;

const Label = styled.div`
  width: 100%;
  opacity: 1;
  font-size: 13px;
  white-space: nowrap;
  font-weight: 700;
  text-transform: capitalize;
`;

const Left = styled.div`
  display: flex;
  gap: 5px;
  flex-direction: column;
`;

const SelectInputText = styled.div`
  font-size: 15px;
  white-space: nowrap;
  font-weight: 500;
`;
const SelectInputButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 3px;
`;

export default function DropDownInput(props) {
  const { setForm } = useContext(Context);
  let {
    value,
    placeholder,
    onChange,
    options,
    label,
    style,
    popupComponent,
    isLinkBased,
  } = props;

  if (isLinkBased) {
    value = window.location.pathname;
    onChange = (newVal) => {
      console.log("input------", newVal);
      goTo(newVal, { isReplace: true })();
    };
  }

  let valToShow = getLabelFromValue({ value, options });

  let placeholderData = valToShow ? valToShow : placeholder;

  return (
    <Container
      style={style}
      onClick={() => {
        setForm({
          title: placeholder,
          component: popupComponent ? (
            popupComponent
          ) : (
            <PopupSelect
              isLinkBased={isLinkBased}
              value={value}
              options={options}
              onChange={onChange}
            />
          ),
        });
      }}
    >
      <Left>
        {label ? <Label>{label}</Label> : null}

        {placeholderData ? (
          <SelectInputText>{placeholderData}</SelectInputText>
        ) : null}
      </Left>
      <SelectInputButton>
        <AiOutlineDown />
      </SelectInputButton>
    </Container>
  );
}

function getLabelFromValue({ value, options }) {
  if (!options) return ""; // In case of location input

  for (let item of options) {
    if (item.value == value) return item.label;
  }

  return false;
}
